interface WaitForParams {
    condition: () => boolean
    interval: number
    maxRetries?: number
}
export const waitFor = async ({ condition, interval, maxRetries = 5 }: WaitForParams) => {
    let retries = 0
    while (!condition() && (maxRetries ? retries < maxRetries : true)) {
        await new Promise((resolve) => setTimeout(resolve, interval))
        retries++
    }
}
